import { render, staticRenderFns } from "./redirect-settings.vue?vue&type=template&id=259e9e55&scoped=true"
import script from "./redirect-settings.vue?vue&type=script&lang=js"
export * from "./redirect-settings.vue?vue&type=script&lang=js"
import style0 from "./redirect-settings.vue?vue&type=style&index=0&id=259e9e55&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259e9e55",
  null
  
)

export default component.exports